const AUTH_ROUTES = {
  LOGIN: "auth/login/",
  LOGOUT: "auth/user/logout",
  SEND_RESET_PASSWORD_MAIL: "auth/sendResetPasswordMail",
  RESET_PASSWORD: "auth/resetPassword",
};

const HOME_ROUTES = {
  OWNER_FACILITY_LISTING: "owner/facility/list",
  FETCH_ROLES: (params) => `owner/facility-roles/?${params}`,
  FETCH_ROLES_FACILITY: (params) => `facilities/features`,
};
const DASHBOARD = {
  FETCH_STATS: (start_date, end_date, params) =>
    `owner/dashboard/${start_date}/${end_date}/stats/`,
  SHIFT_OPENINGS_TABLE_DATA: (start_date, end_date, params) =>
    `owner/dashboard/${start_date}/${end_date}/?${params}`,
  Week_Budget_Data: (facility_id, start_date, end_date) =>
    `owner/facility/${facility_id}/${start_date}/${end_date}/budget/`,
  STAT_DETAILS: (start_date, end_date, statKey, params) =>
    `owner/dashboard/${start_date}/${end_date}/stats/${statKey}/?${params}`,
  FETCH_FACILITIES: (start_date, end_date, params) =>
    `owner/dashboard/${start_date}/${end_date}/facilities/?${params}`,
  FETCH_FACILITY_DETAILS: (start_date, end_date, facility_id, params) =>
    `owner/dashboard/${start_date}/${end_date}/facilities/${facility_id}/weeks/?${params}`,
  FETCH_FACILITY_EMPLOYEE_DETAILS: (
    start_date,
    end_date,
    facility_id,
    params,
  ) =>
    `owner/dashboard/${start_date}/${end_date}/facilities/${facility_id}/employees/?${params}`,
};

const PDF_SETTINGS = {
  FETCH_PDF_SETTINGS: `owner/pdf-settings/`,
};

const FACILITY_DETAILS = {
  FETCH_PROFILE: (facility_id) => `/owner/facility/${facility_id}/detail/`,
  FACILITY_LIMIT: (facility_id) =>
    `/owner/metrics-limit/facility/${facility_id}/`,
  FACILITY_EMPLOYEES: (facility_id, urlParams) =>
    `owner/facility/${facility_id}/employees/?${urlParams}`,
  NURSE_TYPE_LISTING: (facility_id, start_date, end_date, urlParams) =>
    `owner/facility/${facility_id}/${start_date}/${end_date}/nurses/?${urlParams}`,
  FACILITY_DETAILS: (facility_id, start_date, end_date) =>
    `owner/facility/${facility_id}/${start_date}/${end_date}/detail/`,
  SCHEDULE_LISTING: (facility_id, start_date, end_date) =>
    `owner/facility/${facility_id}/${start_date}/${end_date}/schedules/`,
  NURSE_ACTION: (facility_id, nurse_id) =>
    `/owner/facility/${facility_id}/nurse/action/${nurse_id}/`,
};
const COMMON_API = {
  FETCH_JOB_TITLES: "common/job-titles",
};

const APPLICANTS_MODAL = {
  APPLICANTS_MODAT_STATS: (facilityId, startDate, endDate, params) =>
    `/owner/facility/${facilityId}/${startDate}/${endDate}/nurses/stats/?${params}`,
  EMPLOYEE_SHIFTS: (facilityId, employeeId, startDate, endDate, params) =>
    `/owner/facility/${facilityId}/employees/${employeeId}/schedules/${startDate}/${endDate}/`,
  FACILITY_SHIFTS: (facilityId, startDate, endDate, params) =>
    `/owner/facility/${facilityId}/shifts/${startDate}/${endDate}/?is_detailed=true&dashboard_2=true`,
  ASSIGN_SHIFTS: (facilityId, employeeId, endDate, params) =>
    `/owner/facility/${facilityId}/employees/${employeeId}/assign-shift/`,
};
const HDDP_TRACKER = {
  FETCH_ALL_DEPARTMENTS_NEW: "facilities/central-department/",
  HPPD_TRACKER_DETAILS: (params) =>
    `owner/hppd_tracker/owner-dashboard/?${params}`,
  JOBTITLE_TRACKER_DETAILS: (params) =>
    `owner/hppd_tracker/owner-dashboard-job-wise/?${params}`,
  UPDATE_JOBS: `/owner/hppd_tracker/job_title_target/`,
  GET_JOBTITLE_TRACKER_DETAILS: (params) =>
    `owner/hppd_tracker/owner-dashboard-facility-job-wise?${params}`,
  GET_JOBTITLE_TRACKER_DETAILS_V2: (params) =>
    `owner/hppd_tracker/owner-dashboard-facility-job-wise-v2/?${params}`,
  UPDATE_JOBS_TRACK: (params) =>
    `owner/hppd_tracker/owner-dashboard-facility-job-wise/${params}/`,
  UPDATE_TARGET_V2: (params) =>
    `owner/hppd_tracker/owner-dashboard-facility-job-wise-v2/?${params}`,
  DELETE_GROUP: (targetHppdId, groupId) =>
    `owner/hppd_tracker/${targetHppdId}/delete_title_group/${groupId}/`,
  GROUP_DETAILS: (groupId) => `owner/hppd_tracker/groups-details/${groupId}/`,
  HPPD_CENSUS_LISTING: (params) => `owner/census/?${params}`,
  HPPD_TARGET_LISTING: (params) => `/owner/hppd_tracker/?${params}`,
  HPPD_CENSUS_UPDATE: "owner/census/",
  HPPD_TARGET_UPDATE: "owner/hppd_tracker/",
  FETCH_HDDP_FACILITY: (facilityId, params) =>
    `owner/hppd_tracker/${facilityId}?${params}`,
  // Job Title Groups APIs
  JOB_TITLE_GROUPS_LIST: (params) =>
    `owner/hppd_tracker/job_title_groups/?${params}`,
  JOB_TITLE_GROUPS_CREATE: `owner/hppd_tracker/job_title_groups/`,
  JOB_TITLE_GROUPS_UPDATE: (groupId) =>
    `owner/hppd_tracker/job_title_groups/${groupId}/`,
  JOB_TITLE_GROUPS_DELETE: (groupId) =>
    `owner/hppd_tracker/job_title_groups/${groupId}/`,
  JOB_TITLE_GROUPS_AVAILABLE_JOB_TITLES: (params) =>
    `owner/hppd_tracker/job_title_groups/available-job-titles?${params}`,
  JOB_TITLE_GROUPS_TARGETS: (groupId) =>
    `owner/hppd_tracker/job_title_groups/${groupId}/targets/`,
  JOB_TITLE_GROUPS_TARGETS_GET: (groupId, params) =>
    `owner/hppd_tracker/job_title_groups/${groupId}/targets/?${params}`,
};

const SUB_ADMINS = {
  SUBADMINS_LISTING: (params) => `owner/facility-subadmin/?${params}`,
  CHANGE_SUBADMIN_STATUS: (id) => `owner/facility-subadmin/${id}/`,
  ADD_SUBADMIN: `owner/sub-admin/`,
  ADD_ROLE: "owner/roles/",
  PATCH_ROLE: (role_id) => `owner/roles/${role_id}/`,
  PATCH_SUBADMIN: `owner/sub-admin/update/`,
  GET_ROLE_DETAILS: (role_id) => `owner/roles/${role_id}/`,
  DELETE_SUBADMIN: (id) => `/owner/sub-admin/${id}/`,
  CHANGE_SUBADMIN_PASSWORD: `owner/sub-admin/reset-password/`,
};

const OVERTIME_MANAGEMENT = {
  GET_FACILITY_LIST: "/owner/overtime-management/",
  GET_OVERTIME_STATS: "/owner/overtime-management/stats/",
  GET_EMPLOYEE_LIST: (facility_id) =>
    `/owner/overtime-management/${facility_id}/overtime-employees/`,
  GET_SHIFT_DETAILS: (facility_id, employee_id) =>
    `/owner/overtime-management/${facility_id}/overtime-employees/${employee_id}/`,
  GET_REPLACEMENT_CANDIDATES: (facility_id, shift_id) =>
    `/owner/overtime-management/${facility_id}/shift-applicant/${shift_id}/available-employees/`,
  MAKE_REPLACEMENT_OFFER: (facility_id, shift_applicant_id) =>
    `/owner/overtime-management/${facility_id}/shift-applicant/${shift_applicant_id}/make-offer/`,
  RESEND_REPLACEMENT_OFFER: (facility_id, shift_applicant_id) =>
    `/owner/overtime-management/${facility_id}/shift-applicant/${shift_applicant_id}/re-send/`,
};
const PBJ_MANAGEMENT = {
  GET_PBJ_FACILITY_LIST: "/owner/pbj/facilities/",
  GET_PBJ_LABOR_CATEGORIES: (facilityId, params) =>
    `/owner/pbj/facilities/${facilityId}/labor-categories/?${params}`,
  GET_PBJ_LABOR_JOBS_TITLES: (facilityId, jobId, params) =>
    `/owner/pbj/facilities/${facilityId}/job-titles/${jobId}/employees/?${params}`,
  GET_PBJ_LABOR_EMPLOYEE_SHIFTS: (facilityId, jobId, employeeId, params) =>
    `/owner/pbj/facilities/${facilityId}/job-titles/${jobId}/employees/${employeeId}/shifts/?${params}`,
  PBJ_EXPORT_REPORT: (facilityId, params) =>
    `/owner/pbj/facilities/${facilityId}/export/?${params}`,
};

const PAYROLL_MANAGEMENT = {
  GET_PAYROLL_FACILITY_LIST: (params) => `/owner/payroll-management/${params}`,
  GET_FACILITY_DETAIL: (facilityId, params) =>
    `/owner/payroll-management/${facilityId}/summary/?${params}`,
  GET_EMPLOYEE_HOURS: (facilityId, employeeId, params) =>
    `/owner/payroll-management/${facilityId}/employees/${employeeId}/timesheets/${params}`,
  GET_PAYROLL_STATS: (startDate, endDate) =>
    `/owner/payroll-management/stats/?start_date=${startDate}&end_date=${endDate}`,
  APPROVE_EMPLOYEE_TIMESHEET: (facilityId, employeeId) =>
    `/owner/payroll-management/${facilityId}/employees/${employeeId}/timesheets/approve/`,
  REJECT_EMPLOYEE_TIMESHEET: (facilityId, employeeId) =>
    `/owner/payroll-management/${facilityId}/employees/${employeeId}/timesheets/reject/`,
  TOGGLE_MISSED_PUNCHES: (facilityId) =>
    `/owner/payroll-management/${facilityId}/employees/missed-punches/action/`,
  DELETE_BONUS: (facilityId, bonusId) =>
    `/owner/payroll-management/${facilityId}/employees/bonuses/${bonusId}/`,
  TOGGLE_CREDENTIALS: (facilityId, credentialId) =>
    `/owner/payroll-management/${facilityId}/employees/pending-credentials/${credentialId}/action/`,
  APPROVE_PTO: (facilityId) =>
    `/owner/payroll-management/${facilityId}/pto-bulk-accept/`,
  REJECT_PTO: (facilityId) =>
    `/owner/payroll-management/${facilityId}/pto-bulk-reject/`,

  // Listing API
  GET_ALL_EMPLOYEES: (facilityId, params) =>
    `/owner/payroll-management/${facilityId}/employees/${params}`,
  GET_CREDENTIALS_PENDING: (facilityId, params) =>
    `/owner/payroll-management/${facilityId}/employees/pending-credentials/${params}`,
  GET_PENDING_BONUS: (facilityId, params) =>
    `/owner/payroll-management/${facilityId}/employees/bonuses/${params}`,
  GET_IPAD_CLOCK: (facilityId, params) =>
    `/owner/payroll-management/${facilityId}/employees/ipad-clock-ins/${params}`,
  GET_MISSED_PUNCHES: (facilityId, params) =>
    `/owner/payroll-management/${facilityId}/employees/missed-punches/${params}`,
  GET_PTO_REQUEST: (facilityId, params) =>
    `/owner/payroll-management/${facilityId}/pto-requests/${params}`,
  GET_NO_BANK_ACCOUNT: (facilityId, params) =>
    `/owner/payroll-management/${facilityId}/employees-without-bank/${params}`,
  GET_INCOMPLETE_ONBOARDING: (facilityId, params) =>
    `/owner/payroll-management/${facilityId}/incomplete-onboarding/${params}`,
  GET_OVERTIME: (facilityId, params) =>
    `/owner/payroll-management/${facilityId}/employees/overtime-summary/${params}`,
  GET_PAYROLL_EMPLOYEES: (facility_id, params) =>
    `/owner/payroll-management/${facility_id}/employees/conversion-due/${params}`,
  UPDATE_EMPLOYMENT_TYPE: (id) =>
    `/facilities/employees/${id}/employment-type/`,
};
//Test
const HPPD_OT_TRACKER = {
  GET_HPPD_FACILITY_LIST: "/owner/hppd/facilities/",
  GET_DEPARTMENT_FROM_FACILITY: (facilityId) =>
    `/owner/hppd/facilities/${facilityId}/department-groups/`,
  GET_DEPARTMENT_DAYS: (department_id) =>
    `/owner/hppd/facilities/${department_id}/daily-stats/`,
  GET_DAILY_SCHEDULES: (facilityId, date) =>
    `/owner/hppd/facilities/${facilityId}/${date}/daily-schedules/`,
  GET_DAILY_OFF_SCHEDULES: (facilityId, date) =>
    `/owner/hppd/facilities/${facilityId}/${date}/daily-off-schedules/`,
  GET_DAILY_OVERTIME_EMPLOYEES: (facilityId, date) =>
    `/owner/hppd/facilities/${facilityId}/${date}/daily-overtime-employees/`,
  GET_HPPD_OT_DEPARTMENT_DETAILS: (facilityId, departmentId) =>
    `/owner/hppd/facilities/${facilityId}/department/${departmentId}`,
  PATCH_HPPD_OT_DEPARTMENT_UPDATE: (facilityId, departmentId) =>
    `/owner/hppd/facilities/${facilityId}/department/${departmentId}/update/`,
};

const REPORT_GENERATION = {
  AVAILABLE_EMPLOYEES: `owner/report-center/employee-listing/?`,
  GENERATE: (params) => `/owner/report-center/${params}`
}
const ENDPOINTS = {
  ...AUTH_ROUTES,
  ...HOME_ROUTES,
  ...DASHBOARD,
  ...FACILITY_DETAILS,
  ...COMMON_API,
  ...APPLICANTS_MODAL,
  ...PDF_SETTINGS,
  ...HDDP_TRACKER,
  ...SUB_ADMINS,
  ...OVERTIME_MANAGEMENT,
  ...PBJ_MANAGEMENT,
  ...PAYROLL_MANAGEMENT,
  ...HPPD_OT_TRACKER,
  ...REPORT_GENERATION,
};

export { ENDPOINTS };
